/*
 * @Author: Hyman Choi
 * @Date: 2021-01-11 08:35:55
 * @LastEditTime: 2022-01-26 17:10:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\main.js
 */
import Vue from "vue";
import Navigation from 'vue-navigation'

import Cookies from "js-cookie";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import '@/assets/icon/iconfont/iconfont.css'

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import ElSelectTree from 'el-select-tree';

// 全局引用 echarts
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

// 全局使用 lodash
import _ from 'lodash'
Vue.prototype._ = _ 

import App from "./App";
import store from "./store";
import router from "./router";

import "@/styles/index.scss"; // global css
import i18n from "./lang"; // internationalization
import "@/icons"; // icon
import "@/permission"; // permission control
import "@/utils/filters.js"; // global javascript filters

// 配置文件
import config from "./utils/config";
Vue.prototype.config = config;

/* utils */
import utils from "@/utils/utils";
import {setCloudUrl2Cookie, setOssBucket2Cookie, setPreviewUrl2Cookie} from "@/utils/auth";
Vue.prototype.utils = utils;

// 全局mixin
import mixinsIndex from '@/views/mixins/index'
Vue.mixin(mixinsIndex)

Vue.use(Navigation,{router})

Vue.use(ElementUI, {
	size: Cookies.get("size") || "medium", // set element-ui default size
	i18n: (key, value) => i18n.t(key, value),
});
Vue.use(ElSelectTree)

Vue.config.productionTip = false;

//cookie设置
setCloudUrl2Cookie(process.env.VUE_APP_BASE_API_ROOT + "/")
setPreviewUrl2Cookie(process.env.VUE_APP_RESOURCES)
setOssBucket2Cookie(process.env.VUE_APP_OSSBUCKET)

//编辑器组件注册
import { Boot } from '@wangeditor/editor'
import attachmentModule from '@wangeditor/plugin-upload-attachment'
Boot.registerModule(attachmentModule)

new Vue({
	el: "#app",
	router,
	store,
	i18n,
	render: (h) => h(App),
});
